import React from "react";
import {css, SerializedStyles} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter, mb, mt, onDesktop, w100} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

const expertImg = require("../../../images/expert.png");

interface IProps {
    onButtonClick?: () => void;
    customizedBoxWrapper?: SerializedStyles;
}

export const ExpertAdvice = (props: IProps) => {
    const {onButtonClick, customizedBoxWrapper} = props;

    return (
        <div css={customizedBoxWrapper || boxWrapper}>
            <div css={textSectionStyle}>
                <Image src={expertImg} alt="Zdjęcie eksperta" width="94px" height="56px" css={expertImage} />

                <div>
                    <Text variant="body_copy_1" strong css={mb(1)}>
                        Bezpłatna porada eksperta
                    </Text>
                    <Text variant="info_txt_1">
                        Nasz ekspert udzieli Ci porady kredytowej, wyszuka najbardziej optymalne rozwiązanie kredytowe i pomoże załatwić formalności na dalszym
                        etapie procesu.
                    </Text>
                </div>
            </div>

            <Button
                variant="filled_primary"
                size="small"
                css={w100}
                onClick={onButtonClick}
                dataTestId={CREDIT_PAGES_IDS.CREDITWORTHINESS_SUBPAGE.SCHEDULE_CALL_BUTTON}
            >
                <Text variant="button_small">umów się na rozmowę</Text>
            </Button>
        </div>
    );
};

const boxWrapper = css`
    ${mt(3)};

    ${onDesktop(mt(4))};
`;

const textSectionStyle = css`
    ${flex("flex-start", "center")};
    gap: ${calculateRemSize(1)};
    ${mb(3)};
`;

const expertImage = css`
    ${flexAbsoluteCenter};
    border-radius: 50%;
    min-width: ${calculateRemSize(7)};
    min-height: ${calculateRemSize(7)};
`;
import React from "react";
import {css, SerializedStyles} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter, mb, mt, onDesktop, w100} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

const expertImg = require("../../../images/expert.png");

interface IProps {
    onButtonClick?: () => void;
    customizedBoxWrapper?: SerializedStyles;
}

export const ExpertAdvice = (props: IProps) => {
    const {onButtonClick, customizedBoxWrapper} = props;

    return (
        <div css={customizedBoxWrapper || boxWrapper}>
            <div css={textSectionStyle}>
                <Image src={expertImg} alt="Zdjęcie eksperta" width="94px" height="56px" css={expertImage} />

                <div>
                    <Text variant="body_copy_1" strong css={mb(1)}>
                        Bezpłatna porada eksperta
                    </Text>
                    <Text variant="info_txt_1">
                        Nasz ekspert udzieli Ci porady kredytowej, wyszuka najbardziej optymalne rozwiązanie kredytowe i pomoże załatwić formalności na dalszym
                        etapie procesu.
                    </Text>
                </div>
            </div>

            <Button
                variant="filled_primary"
                size="small"
                css={w100}
                onClick={onButtonClick}
                dataTestId={CREDIT_PAGES_IDS.CREDITWORTHINESS_SUBPAGE.SCHEDULE_CALL_BUTTON}
            >
                <Text variant="button_small">umów się na rozmowę</Text>
            </Button>
        </div>
    );
};

const boxWrapper = css`
    ${mt(3)};

    ${onDesktop(mt(4))};
`;

const textSectionStyle = css`
    ${flex("flex-start", "center")};
    gap: ${calculateRemSize(1)};
    ${mb(3)};
`;

const expertImage = css`
    ${flexAbsoluteCenter};
    border-radius: 50%;
    min-width: ${calculateRemSize(7)};
    min-height: ${calculateRemSize(7)};
`;
